import { Component, Inject, OnInit, signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoutePageComponent } from '../../shared/route-page/route-page.component';
import { globalConstants } from '../../shared/global-constants';
import { CommonModule } from '@angular/common';
import { APP_CONFIG, AppConfig } from '../../../../app.config';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PaymentService } from '../../../services/payment-portal.service';
import { ChargePaymentResponse, IPayload, PolicyDetails, UIResponse } from '../../../services/base/policy-details';
import { ToastService } from '../../../services/toast.service';
import { ModalService } from '../../../services/modal.service';
import { map } from 'rxjs';
import { ButtonComponent } from "@pacificspecialtyinsurancecompany/psic-ng-components";

@Component({
    selector: 'app-payment-summary',
    imports: [RoutePageComponent, CommonModule, ButtonComponent],
    templateUrl: './payment-summary.component.html',
    styleUrl: './payment-summary.component.scss'
})
export class PaymentSummaryComponent implements OnInit {
    globalConstants = globalConstants;
    isMobile = toSignal(
        this.breakpointObserver.observe(['(max-width: 768px)']).pipe(map(r => r.matches)),
        { initialValue: this.breakpointObserver.isMatched('(max-width: 768px)') }
    );
    policyDetails = signal<PolicyDetails | null>(null);
    paymentDetails = signal<IPayload | null>(null);
    chargePaymentResponse = signal<ChargePaymentResponse | null>(null);
    bankAcctType = computed(() => {
        const response = this.chargePaymentResponse();
        if (!response) return '';
        if (response.bankAcctType === 'Checking') return 'EFT- CHECKING ACCOUNT';
        if (response.bankAcctType === 'Savings') return 'EFT- SAVINGS ACCOUNT';
        return 'CREDIT CARD';
    });
    policies = signal<any[]>([]);

    constructor(
        private toastService: ToastService,
        private modalService: ModalService,
        private paymentService: PaymentService,
        @Inject(APP_CONFIG) private config: AppConfig,
        private breakpointObserver: BreakpointObserver
    ) {}

    ngOnInit(): void {
        const details = this.paymentService.getPaymentDetails();
        this.paymentDetails.set(details);
        this.policyDetails.set(details?.retrievePolicyResponse?.details.policyDetails?.at(-1) || null);
        this.chargePaymentResponse.set(details?.chargePaymentResponse || null);

        this.policies.set(this.config.interestedProtectionPlans.map((plan: any) => ({
            ...plan,
            icon: `assets/images/${plan?.product?.toLowerCase()}.svg`
        })));
    }

    goToPage(item: any) {
        if (item?.linkURL) {
            window.open(item.linkURL, '_blank');
        }
    }

    downloadReceipt() {
        let payload: IPayload = {} as IPayload;
        payload.autoGeneratedKey = this.paymentDetails()?.chargePaymentResponse?.autogeneratedkey || '';
        payload.quoteId = this.policyDetails()!.policyNumber || '';
        payload.transactionId = this.paymentDetails()?.chargePaymentResponse?.transactionId || '';
        this.paymentService.callPaymentService(payload, globalConstants.downloadReceiptService).subscribe(
            (res: UIResponse) => {
                if (res.statusCode === 200) {
                    window.open(res.payload.receiptLocation);
                    this.toastService.add({
                        type: 'success',
                        title: '',
                        message: 'Receipt downloaded successfully.',
                    });
                } else {
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Error downloading Receipt.',
                    });
                }
            }
        );
    }

    emailReceipt() {
        const popupCreditCard = {
            type: 'actionDialog',
            imageSrc: '../../../../assets/images/emailicon.svg',
            message: 'A link to access the <br> receipt will be sent <br> to: ',
            confirm: 'Send',
            cancel: 'Cancel',
            fields: [
                {
                    name: 'email',
                    helpIcon: false,
                    caption: 'Email',
                    id: 'email',
                    placeholder: 'Email',
                    type: 'email',
                    required: true
                }
            ],
        };

        this.modalService.confirm(popupCreditCard).subscribe((popupCallbackDetail) => {
            if (popupCallbackDetail[0] === 'Send') {
                let payload: IPayload = {} as IPayload;
                payload.autoGeneratedKey = this.paymentDetails()?.chargePaymentResponse?.autogeneratedkey || '';
                payload.emailId = popupCallbackDetail[1];
                payload.quoteId = this.policyDetails()!.policyNumber || '';
                payload.transactionId = this.paymentDetails()?.chargePaymentResponse?.transactionId || '';
                this.paymentService.callPaymentService(payload, globalConstants.emailReceiptService).subscribe(
                    (res: UIResponse) => {
                        if (res.statusCode === 200) {
                            this.toastService.add({
                                type: 'success',
                                title: '',
                                message: `The receipt link was successfully sent to ${popupCallbackDetail[1]}`,
                            });
                        } else {
                            this.toastService.add({
                                type: 'error',
                                title: 'Error',
                                message: "We weren't able to email your download link. Let's try again.",
                            });
                        }
                    }
                );
            }
        })
    }
}
